<template>
  <div>
    <template v-if="appointment.type == 'walkin'">
      <template v-if="appointment.call_channel == 'web'">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="yellow darken-2">flash_on</v-icon>
          </template>
          <span>Walk-in</span>
        </v-tooltip>
      </template>
      <template v-else>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="red darken-2">phone</v-icon>
          </template>
          <span>Hotline</span>
        </v-tooltip>
      </template>
    </template>
    <template v-else>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="blue darken-2">book</v-icon>
        </template>
        <span>Appointment</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    appointment: Object,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
